import { styled } from '@mui/material';
import { COLORS } from '../../theme/color';

export const OrderCON = styled('div')``;

export const OrderTableCON = styled('div')`
  background: ${COLORS.White};
`;

export const TableHeaderCON = styled('div')`
  padding: 32px 32px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const OrderStatusCON = styled('div')<{ status?: string }>`
  background: ${({ status }) =>
    status?.toLocaleLowerCase().includes('cancelled')
      ? '#FFF0F3'
      : status?.toLocaleLowerCase().includes('completed')
      ? '#EEFBF4'
      : '#FFF6C7'};
  color: ${({ status }) =>
    status?.toLocaleLowerCase().includes('cancelled')
      ? COLORS.MainRed
      : status?.toLocaleLowerCase().includes('completed')
      ? '#27AE60'
      : '#F79009'};
  display: flex;
  padding: 4px 16px;
  font-weight: 500;
  align-items: center;
  border-radius: 8px;
  gap: 8px;

  p {
    font-size: 14px;
    font-style: normal;
    font-weight: 400;

    text-transform: capitalize;
    line-height: 24px;
  }
`;

export const PaymentStatusCON = styled('div')<{ status: string }>`
  padding: 4px 12px;
  border-radius: 16px;
  width: fit-content;
  background-color: ${({ status }) =>
    status?.toLocaleLowerCase().includes('pending')
      ? '#FEF9EC'
      : status?.toLocaleLowerCase().includes('completed') || status?.toLocaleLowerCase().includes('success')
      ? '#F5FBEF'
      : '#EFF1FB'};
  color: ${({ status }) =>
    status?.toLocaleLowerCase().includes('pending')
      ? '#FAB613'
      : status?.toLocaleLowerCase().includes('completed') || status?.toLocaleLowerCase().includes('success')
      ? '#1C9A46'
      : '#4A69E2'};
`;
